export default __webpack_public_path__ + "static/media/ios-dev.0f4161d6.jpg";